import { TemplateRef } from '@angular/core';

export interface ProjectionInstance {
  [slotName: string]: TemplateRef<unknown>;
}
